import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { findPartnerBySlug } from "@/data/partners";

const STORAGE_KEY = "btc_partner_from";
const DISMISS_KEY = "btc_partner_from_dismissed";

export default function PartnerWelcome() {
  const location = useLocation();
  const navigate = useNavigate();
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    if (from) {
      const p = findPartnerBySlug(from);
      if (p) {
        sessionStorage.setItem(STORAGE_KEY, p.slug);
        sessionStorage.removeItem(DISMISS_KEY);
      }
    }
    const stored = sessionStorage.getItem(STORAGE_KEY);
    const dismissed = sessionStorage.getItem(DISMISS_KEY);
    if (stored && !dismissed) setPartner(findPartnerBySlug(stored));
    else setPartner(null);
  }, [location.search]);

  if (!partner) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setPartner(null);
  };

  return (
    <div
      data-testid="partner-welcome-banner"
      className="relative bg-gradient-to-r from-[#E8956B] to-[#CE744A] text-white"
    >
      <div className="max-w-7xl mx-auto px-5 py-3 flex items-center justify-center gap-3 text-center">
        <Heart size={18} fill="currentColor" className="hidden sm:block shrink-0" />
        <p className="text-sm sm:text-base font-semibold">
          Welcome, <span className="font-black">{partner.name}</span> friends! 💗 Joining is
          free and every order is 100% escrow-protected.
        </p>
        <button
          data-testid="partner-welcome-cta"
          onClick={() => navigate("/shop")}
          className="hidden sm:inline-flex shrink-0 bg-white text-[#CE744A] font-bold rounded-full px-4 py-1 text-sm hover:bg-neutral-100 transition-colors"
        >
          Start shopping
        </button>
      </div>
      <button
        data-testid="partner-welcome-dismiss"
        onClick={dismiss}
        aria-label="Dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors"
      >
        <X size={18} />
      </button>
    </div>
  );
}
